import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
// hocs
import { withDropzone } from 'hocs/index'
// icons
import UploadIconOrigin from '@mui/icons-material/Upload'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'
// context
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'

// styled
const Wrapper = styled((props) => <Grid {...props} />)`
  height: 80px;
  border: 2px dashed ${colors.gray320};
  border-radius: 6px;
  font-weight: bold;
`

const Link = styled.span`
  cursor: pointer;
  color: ${colors.blue500};
`

const UploadIcon = styled(UploadIconOrigin)`
  ${size('35px')};

  path {
    fill: ${colors.blue500};
  }
`

const ReviewDropzone: React.FunctionComponent<any> = ({ open }) => {
  // context
  const { entity } = React.useContext(ActivitiesListAPIContext)
  const { handleAddLinkClick } = React.useContext(ActivitiesListBLContext)

  const onAddLinkClick = () => {
    handleAddLinkClick(entity)
  }

  return (
    <Wrapper container justifyContent={'center'} alignItems={'center'}>
      <Grid container alignItems={'center'} style={{ width: 'auto' }}>
        <UploadIcon />

        <Grid style={{ marginLeft: '10px', fontSize: '18px' }}>
          Drop files to attach, <Link onClick={open}>browse</Link>, or <Link onClick={onAddLinkClick}>add link</Link>
        </Grid>
      </Grid>
    </Wrapper>
  )
}

export default withDropzone(ReviewDropzone)
